import { z } from "zod";

export const syncTriggerSchema = z.object({
	entity: z.enum([
		"business_partners",
		"items",
		"warehouses",
		"item_warehouses",
		"orders",
		"quotations",
		"sales_persons",
		"currency_rates",
		"document_status",
		"load_report_arrivals",
	]),
	direction: z.enum(["inbound", "outbound"]),
	fullSync: z.boolean().default(false),
	sinceDays: z.coerce.number().int().positive().max(365).optional(),
	recordId: z.string().uuid().optional(),
});

export type SyncTriggerInput = z.infer<typeof syncTriggerSchema>;

export const updateSyncConfigSchema = z.object({
	direction: z.enum(["inbound", "outbound", "bidirectional"]).optional(),
	conflictResolution: z
		.enum(["sap_wins", "crm_wins", "last_write_wins", "manual_review"])
		.optional(),
	isEnabled: z.boolean().optional(),
	scheduleCron: z.string().max(100).nullable().optional(),
});

export type UpdateSyncConfigInput = z.infer<typeof updateSyncConfigSchema>;
